export default function Footer() {
  return (
    <footer className="container">
      <div className="container">
        <div className="footer row justify-content-center">
          <div className="col-auto">
            Github:{" "}
            <a href="https://github.com/lucianoaraus">
              <b>@lucianoaraus</b>
            </a>
            - copyright @ All right reserved
          </div>
        </div>
      </div>
    </footer>
  );
}
